import { render, staticRenderFns } from "./zhoubao.vue?vue&type=template&id=75348e3a&scoped=true&"
import script from "./zhoubao.vue?vue&type=script&lang=js&"
export * from "./zhoubao.vue?vue&type=script&lang=js&"
import style0 from "./zhoubao.vue?vue&type=style&index=0&id=75348e3a&prod&lang=less&"
import style1 from "./zhoubao.vue?vue&type=style&index=1&id=75348e3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75348e3a",
  null
  
)

export default component.exports